export const AUTH_TOKEN = 'UNILAB/auth/TOKEN';
export const REFRESH_TOKEN = 'UNILAB/auth/REFRESH_TOKEN';
export const LOCALE = 'UNILAB/main/LOCALE';

export function writeToLocalState(key: string, state: any) {
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch (e) {
    throw e;
  }
}

export const getFromLocalStorage = (key: string) => {
  return JSON.parse(localStorage.getItem(key) || '""');
};

export function clearLocalState(key: string) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    throw e;
  }
}
